import type { RoundStoreState } from "../../state/roundReducers.js";
export function newSettlements(previous: RoundStoreState, current: RoundStoreState) {
  if (previous.lastSyncAt !== current.lastSyncAt) return [];
  return current.myBets.filter(
    (bet) =>
      (bet.status === "won" || bet.status === "lost") &&
      previous.myBets.find((known) => known.betId === bet.betId)?.status !== bet.status,
  );
}
